import { i18n } from '@/api/i18n';
/*
 * @Description: 枚举对象定义
 */
/**
 * @description: 枚举对象 生成适合select控件使用的options数组
 * @param reverse
 * @return:
 */
export const buildkeyValues = (enumObj, reverse) => {
  let ret = []
  for (var key in enumObj) {
    if (enumObj.hasOwnProperty(key)) {
      if (!reverse) {
        ret.push({ key: key, value: enumObj[key] })
      } else {
        ret.push({ key: enumObj[key], value: key })
      }
    }
  }
  return ret
}

export const
  WMS3Constants = {
    YES: 1,
    NO: 0
  }

export const InboundScanType = {
  RETURN_ORDER_NO: { type: -2, name: '客退单号' },
  RETURN_BATCH_NO: { type: -1, name: '客退批次号' },
  OUT_INBOUND_NO: { type: 0, name: '商家采购单号' },
  PURCHASE_INBOUND_NO: { type: 1, name: '采购单号' },
  AFTER_SALES_INBOUND_NO: { type: 2, name: '售后入' },
  SHIP_NO: { type: 21, name: '运单号' },
  PACKAGE_NO: { type: 22, name: '包裹号' },
  CARTON_NO: { type: 23, name: '箱号' }
}

export const
  InboundStatus = {
    // 初始化
    '-1': 'initializing',
    // 待验收
    0: 'inboundStatus0',
    // 验收中
    1: 'inboundStatus1',
    // 已完验
    2: 'inboundStatus2',
    // 部分验收
    3: 'inboundStatus3',
    // 全部验收
    4: 'inboundStatus4',
    // 全部拒收
    5: 'inboundStatus5',
    // 暂保管
    6: 'inboundStatus6',
    // 集齐发青龙
    7: 'inboundStatus7'
  }
export const
  InboundStatusValue = {
    TobeReceiving: 0,
    Receiving: 1,
    CompleteReceiving: 2,
    PartClosed: 3,
    Closed: 4,
    RejectClosed: 5,
    TempKeepIt: 6,
    SentDMS: 7
  }
export const
  InboundType = {
    /// 一般入库
    it01: 'inboundType01', // 为什么叫inboundType01
    /// 内配入库
    it02: 'inboundType02',
    /// 客户退货
    it03: 'inboundType03',
    /// 备件库入大库
    it04: 'inboundType04',
    /// 样品返库
    it05: 'inboundType05',
    /// 大家电再投
    it06: 'inboundType06',
    /// 备件库驳回入库
    it07: 'inboundType07',
    /// 生鲜加工
    it08: 'inboundType08',
    /// 图书样品
    it09: 'inboundType09',
    /// 搬仓入库
    it10: 'inboundType10',
    /// 售后入库
    it17: 'inboundType17',
    /// 维保入库
    it18: 'inboundType18',
    /// 搬仓入库
    it19: 'inboundType19',
    /// 调拨入库
    it20: 'inboundType20',
  }
export const InboundTypeValue = {
  /// 一般入库
  Normal: 'it01', // 为什么叫inboundType01
  /// 内配入库
  Trans: 'it02',
  /// 客户退货
  Return: 'it03',
  /// 备件库入大库
  SpareParts2Storage: 'it04',
  /// 样品返库
  SampleStorage: 'it05',
  /// 大家电再投
  ReDelivery: 'it06',
  /// 备件库驳回入库
  SpareReject: 'it07',
  /// 生鲜加工
  FK: 'it08',
  /// 图书样品
  Sample: 'it09',
  /// 搬仓入库
  MoveWare: 'it10',
  /// 逆向入库
  AfterSales: 'it17',
  /// 维保入库
  RmSales: 'it18',
  /// 搬仓入库
  MoveWms: 'it19',
  /// 调拨入库
  TransWms: 'it20',
  /// 售后入库
  RejectWms: 'it12'
}
export const ReceivingStatus = {
  Receiving: 0,
  Full: 1,
  ReceivingOver: 2,
  CountCompleted: 3,
  WaitingForQualityInspection: 6
}
export const UnknownPackageStatus = {
    WAITING: 10,
    PICKED: 20,
    RECEIVING:25,
    WASTING:29,
    WASTED: 30,
    REPICKED: 40,
    COMPLETE: 50
}
export const PackageType = {
  unknownPackage: 1,
  crossPackage: 2,
  deliver:3
}
export const CodeType = {
  goodsCode:1, //商品编码
  goodsBarcode:2,//商品条码
  goodsSerial:3,//商品序列号
  goodsUniqueCode:4,//商品唯一码
  boxRuleCode:11,//箱规编码
  boxRuleBarcode:12,//箱规条码
  lpnCode:13,//LPN编码
  bulkGoodsSerial: 31,// 大批量序列号
}
export const MasterContainerStatus = {
  Idle: 50701101,
  Using: 50701102,
  RemovingShelf: 50701103,
  ToBePutway: 50701104,
  Putwaying: 50701105
}
export const MasterPropertyType = {
  shelfLifeVague: 'shelfLifeVague',
  isDistribution: 'isDistribution',
  isPLU: 'isPLU',
  CJSJCH: 'CJSJCH',
  isdangergoods: 'isdangergoods',
  storeProperty: 'storeProperty',
  IsCarton: 'IsCarton',
  isMedicine: 'isMedicine',
  allowedDay: 'allowedDay',
  adventDay: 'adventDay',
  robot: 'ROBOT',
  isBattery: 'isBattery',
  highValue: 'highvalue',
  multiSerialTracking:'multiSerialTracking',
  getAllProperty: 'shelfLifeVague,CJSJCH,IsCarton,isdangergoods,isDistribution,isMedicine,isPLU,storeProperty,ROBOT,allowedDay,isBattery,adventDay,dangerousUNCode,isPackageBatch,withReadyToShipPackage,breakable,batteryNetWeight,batteryCapacity,batteryCapacityUnit,packingRemark,highvalue,sizeDefinition,multiSerialTracking,exemptFlag,adrScore'
}

// 序列号验收方式
export const SnCollentType = {
  DEFAULT: 0,
  MANUAl: 1,
  AUTO: 2
}
export const LotAttrCodeEnum = {
  // 是否入库单批次
  IsPo: { code: 'isPo', value: 1 },
  // 是否供应商批次
  IsSupplier: { code: 'isSupplier', value: 2 },
  // 保质期商品批属性 生产日期
  ProductionDate: { code: 'production_date_lot', value: 3 },
  // 保质期商品批属性 到期日期
  ExpirationDate: { code: 'expiration_date_lot', value: 4 },
  // 收货日期
  IsRcvDate: { code: 'isRcvDate', value: 5 },
  // plu管理批属性
  IsPLU: { code: 'isPLU', value: 6 },
  IsLogIsticCompany: { code: 'isLogIsticCompany', value: 7 },
  IsOrigin: { code: 'isOrigin', value: 8 },
  // omc 医药批号批属性
  IsLot: { code: 'isLot', value: 9 },
  IsManufacturer: { code: 'isManufacturer', value: 10 },
  // 验收日期
  ReceivingDateLot: { code: 'receiving_date_lot', value: 11 },
  // 包装批号
  IsPackageBatch: { code: 'isPackageBatch', value: 12 }
}
export const ShelfLifeTypeEnum = {
  Day: { code: 'day', value: 1 },
  Month: { code: 'month', value: 2 },
  Year: { code: 'year', value: 3 }
}
export const CancelTypeEnum = {
  byBoxNo: { code: 'byBoxNo', value: 0 },
  byGoodsNo: { code: 'byGoodsNo', value: 1 },
  byContainerNo: { code: 'byContainerNo', value: 2 },
  byBoxRule: { code: 'byBoxRule', value: 3 },
  byGridNo: { code: 'byGridNo', value: 4 },
}
export const DeleteTypeEnum = {
  byBusinessCode: 1,
  byGoods: 2,
  bySerial: 3,
  byBizCodeGoods: 4,
  byBoxNo: 5,
  byGridNo: 6
}

// 在库常量定义

// 盘点类型：静盘、动盘
export const InventoryType = {
  StaticInventory: 1,
  DynamicInventory: 2,
  CycleInventory: 5
}
// 盘点方式：储位盘、商品盘、动销盘、货主盘、LPN盘
export const InventoryMode = {
  CellInventory: '1',
  SkuInventory: '2',
  MoveInventory: '3',
  OwnerInventory: '10',
  LPNInventory: '20'
}

export const SkuInventoryErr = {
  SppVerification1: 6, // 商品盘 商品代码不存在
  SppVerification2: 7, // 商品盘 虚拟商品不能进行静态盘点
  SppVerification3: 8 // 商品盘 库存不足无法判断
}
export const CellInventoryErr = {
  ZwpVerification1: -1, // 储位盘  此储位上有未完成的盘点任务
  ZwpVerification2: 2 // 储位盘  输入的储位不存在
}

export const CheckInventoryType = {
  5: 'cycleTask'
}

// add by gongbinglai 2019.02.01
export const CheckTypeNameLabel = {
  1: 'staticCheckTypeLabel',
  2: 'dynamicCheckTypeLabel',
  9: 'robotStaticCheckTypeLabel',
  10: 'robotDynamicCheckTypeLabel'
}

export const CheckStyleNameLabel = {
  1: 'cellCheckStyleLabel',
  2: 'skuCheckStyleLabel',
  3: 'moveCheckStyleLabel',
  10: 'ownerCheckStyleLabel',
  20: 'LPNType',
  25: 'preciousPlate', //贵品盘1
  26: 'riskPlate', //风险盘
}
export const CheckStatusNameLabel = {
  1: 'checkOneCreateStatusLabel',
  2: 'checkOneStatusLabel',
  3: 'checkOneConfirmStatusLabel',
  4: 'checkTwoCreateStatusLabel',
  5: 'checkTwoStatusLabel',
  6: 'checkTwoConfirmStatusLabel',
  7: 'checkThreeCreateStatusLabel',
  8: 'checkThreeStatusLabel',
  9: 'checkThreeConfirmStatusLabel',
  10: 'checkEndStatusLabel',
  11: 'canceled'
}

export const CheckInventoryStatus = {
  1: 'new',
  2: 'taskInventory',
  3: 'inventoryToComplete'
}

export const CheckInventoryResults = {
  '': '',
  1: 'inventoryBlance',
  2: 'checkProfit',
  3: 'checkLoss'
}

export const CheckOfferTypes = {
  '': '',
  '盘点': 'check',
  '上架': 'PUTAWAY',
  '验收': 'RC',
  '移库': 'MV',
  '补货': 'RP',
  '拣货': 'PK',
  '库内返架': 'PK_RT',
  '复核': 'CK',
  '内配拣货差异': 'DY',
  '发货': 'SM',
  '盘点立库异常': 'CS_AR',
  '病单': 'troubleOrder',
  '播种': 'SOW',
  '内配入库差异': 'DYI',
  '在库搬仓': 'BC'
}
export const CheckComplianceFileStatus = {
  20: 'waitReview',
  30: 'batchPass',
  40: 'pass',
  50: 'reject'
}
// 公用 下拉列表绑定 所需要的key
export const CommonCode = {
  CS_SERVICE_TYPE: 'CS_SERVICE_TYPE', // 业务类型
    CS_INBOUND_TYPE:'CS_INBOUND_TYPE',//入库子业务类型
  CS_DIFF_STATUS: 'CS_DIFF_STATUS', // 差异状态
  CS_PL_TYPE: 'CS_PL_TYPE', // 盘盈亏单类型
  CS_DIFF_CLOSE_CAUSE: 'CS_DIFF_CLOSE_CAUSE', // 差异关闭原因
  CS_EASY_MOVE_TYPE: 'CS_EASY_MOVE_TYPE',
  CS_PL_STATUS: 'CS_PL_STATUS',
  Order_Assign_Level: 'Order_Assign_Level'
}

export const CheckPlType = {
  1: 'checkProfit',
  2: 'checkLoss'
}

export const PlStatusType = {
  PL_SATATUS_CANCEL: '-1',
  PL_STATUS_NEW: '1',
  PL_STATUS_APPROVE: '2',
  PL_STATUS_PASS: '3',
  PL_STATUS_REJECTED: '4',
  PL_STATUS_END: '5',
  PL_STATUS_AUTOFINISH: '6'
}

export const PlDetailStatusType = {
  PLITEM_STATUS_NEW: '1',
  PLITEM_STATUS_APPROVE: '2',
  PLITEM_STATUS_PASS: '3',
  PLITEM_STATUS_REJECTED: '4',
  PLITEM_STATUS_END: '5'
}

export const EnumOutboundType = {
  E1: 'Eclp',
  G3: 'FDCBack',
  P: 'Manufacture',
  G4: 'Mini',
  M: 'Multi',
  G7: 'PhoneDistribute',
  C: 'Purchase',
  S: 'Single'
}

// 订单状态
export const OrderStatusType = {
  STATUS_CHECKING: -1, // 操作中状态
  STATUS_INIT: 0, // 初始化状态
  STATUS_LOCKED: 1, // 锁定状态
  STATUS_FINISHED: 2, // 复核完成
  STATUS_DIFFER_CHECK: 3, // 复核登记差异
  STATUS_DIFFER_PICK: 4, // 拣货登记差异
  STATUS_CANCEL: 404, // 取消的订单
  STATUS_TROUBLE: 120, // 转成病单的订单
  STATUS_PACK_FINISHED: 10, // 订单打包完成
  STATUS_PACK_CANCEL: 11, // 打包拦截取消订单，未打印“逆向退货标签”
  STATUS_PACK_CANCEL_PRINT: 12, // 打包拦截取消订单，已打印“逆向退货标签”
  STATUS_PACK_BACK_STORE: 7, // 复核SU不返架流程，打包待返架
}

// 内配满板状态
export const InnerStatusType = {
  STATUS_INIT: 0, // 初始化状态，未复核
  STATUS_CHECKING: 1, // 正在复核的订单
  STATUS_FINISHED: 2, // 复核完成
  STATUS_DIFFER: 3, // 复核过，但是存在差异的订单
  STATUS_DELIVER: 4, // 已发货
  STATUS_CANCEL: 404 // 复核过，但是存在差异的订单
}

/* ***** outbound *******/
export const OUTBOUND_TYPE = {
  SHAREBUY: 6, // 拼购订单
  CUSTOME: 10, // 普通订单
  PLENTY: 18, // 大宗订单
  BUSINESS: 26, // 商采订单
  BIG_STORE: 12, // 大库出备件库
  BACK_TO_OWNER: 13, // 退供应商
  SAMPLE: 14, // 样品出库
  GIFTS: 15, // 赠品
  SCRAP_TO_OWNER: 19, // 报废单
  B2B: 27 // B2B订单
}

/* ***** outboundType枚举*******/
export const outboundNoTypeEnum = {
  10:'outboundTypeNameCustome', //普通订单
  18:'bulkOrders', //大宗订单
  25:'FOOOrder', //411订单
  26:'commercialProcurementOrder', //商采订单
  27:'outboundTypeNameB2b', //B2B订单
  28:'waveTypeForPicking', //领料单
  12:'bigOutSpareOrder', //大库出备件库
  13:'backToOwnerOrder', //退供应商
  14:'sample', //样品出库
  15:'gifts', //赠品
  19:'scrapListOrder', //报废单
  50:'outboundTypeNameVSP', //VSP订单
  6 :'outboundTypeNameShareBuy', //拼购订单
  70:'transferOutbound' //调拨出库
}

/* ***** check *******/
export const CHECK_STATUS = {
  INIT: 0, // 初始
  CHECKING: -1, // 复核中
  LOCKED: 1, // 锁定状态
  FINISHED: 2, // 复核完成
  DIFFER_CHECK: 3, // 差异复核
  DIFFER_PICK: 4, // 差异捡货
  CANCEL: 404, // 订单取消
  TROUBLE: 120, // 订单转为病单
  PACK_FINISHED: 10 // 打包完成
}

export const CHECK_TYPE = {
  NOMAL: 1, // 一般复核
  REBIN: 2, // Rebin复核
  PACK: 3, // 一般复核 + 打包
  REBIN_PACK: 4 // hkm分选复核打包
}

export const EQUIMETN_TYPE = {
  CHECK: 'review_site', // 复核台
  PACKING: 'pkMachine',// 打包台
  CHECKOUT: 'receiving_site' //验收台
}

export const PLATFORM_NO = {
  NORMAL: 'PlatformNo_Normal', // 一般复核
  REBINWALL: 'PlatformNo_RebinWall' // RebinWall复核
}

export const PLATFORM_TYPE = {
  NORMAL: '50702010', // 一般订单复核类型
  PLENTY: '50702009', // 大宗订单复核类型
  BIG_STORE: '50702004', // 大库出备件库复核类型
  BACK_TO_OWNER: '50702005', // 退供应商
  GIFTS: '50702007', // 赠品复核类型
  REBINWALL: '50702011', // RebinWall复核
  B2B: '50702020', // B2B订单  (未定义)
  PARALLEL: '50702021', // 货票同行复核类型
  SUBSIDY: '50702022', // 节能补贴复核类型
  SURPRISE: '50702023', // 惊喜送复核类型
  SAMPLE: '50702006', // 样品复核类型
  SHAREBUY: '60702018', // 拼购复核类型
  SITEPRE: '60702019', // 站点复核类型
  SITEREDUCE: '60702020' // 站点降级复核类型
}
export const CONTAINER_TYPE = 'containerType'
// add by gongbinglai  内配订单来源
export const EnumInnerOutboundSource = {
  1: 'jdOwnerLabel',
  6: 'thirdPartLabel'
}

// 扫码类型
export const ScanType = {
  SCAN_CODE_TYPE_GOODS: 0, // 扫码类型（商品条码、UPC码）主数据给的0
  SCAN_CODE_TYPE_BARCODE: 1, // 扫码类型（商品条码、UPC码）
  SCAN_CODE_TYPE_SERIAL: 3, // 扫码类型（序列号）
  SCAN_CODE_TYPE_BOXNO: 6, // 扫码类型(箱码)
  SCAN_CODE_TYPE_QRCode: 7 // 扫码类型(二维码)

}
// 出库订单状态
export const OrderType1 = {
  CustomOrder: { code: 'CustomOrder', value: 10 }, // 客单
  ShareBuyOrder: { code: 'ShareBuyOrder', value: 6 }, // 拼购订单
  BigStoreToSpareOrders: { code: 'BigStoreToSpareOrders', value: 12 }, // 大件出备件库
  BackToOwnerOrders: { code: 'BackToOwnerOrders', value: 13 }, // 退供
  BiggerCustomOrders: { code: 'BiggerCustomOrders', value: 18 }, // 大宗订单
  VSPOrder: { code: 'VSPOrder', value: 50 } // VSP订单
}

// 清关模式
export const CustomModelType = {
  All: { code: 'all', value: '' }, // 客单
  ZhiYou: { code: 'zhiYouText', value: 'zhiyou' }, // 拼购订单
  YouZheng: { code: 'youZhengtext', value: 'youzheng' }, // 大件出备件库
  GrKuaiJian: { code: 'grKuaiJianText', value: 'grkuaijian' }
}
// 生产组
export const ProduceGroupType = {
  All: { code: 'all', value: '' }, // 客单
  ZhiYou: { code: '生产', value: 'zhiyou' }, // 拼购订单
  YouZheng: { code: '生产333', value: 'youzheng' }, // 大件出备件库
  GrKuaiJian: { code: '生产2342', value: 'grkuaijian' }
}
export const InnerBasicConst = {
  PLATFORM_NO_INNER: 'PlatformNoInner', //平台类型
  EQUIMETN_TYPE_CHECK: 'review_site',  //设备类型：复核台
  FORM_SET_INNER_SMALL_SCANONE: 'inner_small_scanone', //内配复核台设置界面，启用逐一复核
  PLATFORM_TYPE_VALUE_INNER: '50702003'  //内配复核类型
}

export const SystemID = {
  SYSTEMID_ID: 'ID',
  SYSTEMID_COMMON: 'COMMON', //
  SYSTEMID_CLOUD: 'CLOUD', // 海外直邮
  SYSTEMID_EPT: 'EPT' //
}

export const PackType = {
  PACK_TYPE_ONLY: 1,
  PACK_TYPE_CHECK: 2
}

export const SerialDTO = {
  /* 入库 扫码环节 */
  // 采购进货 */
  CAI_GOU_RU: 'I11',
  // 内配入 */
  NEI_PEI_RU: 'I13',
  // 备件库入大库 */
  BEI_JIAN_RU: 'I34',
  // 客户退货入库 */
  KE_HU_TUI_HUO_RU: 'I32',
  // 仓间调拨入库 */
  DIAO_BO_RU: 'I51',
  // 盘盈入库 */
  PAN_YING_RU: 'PYR',
  /* 出库 扫码环节 */
  // 普通订单出库 */
  DING_DAN_CHU: 'BEX',
  // 内配出 */
  NEI_PEI_CHU: 'SEX',
  // 大库出备件库 */
  BEI_JIAN_CHU: 'SBK',
  // 退供应商 */
  TUI_VENDOR_CHU: 'TG',
  // 仓间调拨出 */
  DIAO_BO_CHU: 'CJDC',
  // 大库报废 */
  DKBF_CHU: 'DKBF',
  // 赠品出库 */
  ZENG_PIN_CHU: 'ZPC',
  // 采购配出 */
  CAI_GOU_PEI_CHU: 'CGPC',
  // 盘亏出库 */
  PAN_KUI_CHU: 'PKC',
  /* 商品所屬地状态码 */
  // 在京东，在库 */
  ZAI_KU: 'ZK',
  // 在京东，在途 */
  ZAI_TU: 'ZT',
  // 不在京东，或入备件库 */
  LEAVE: 'LEAVE',

  // 业务接口调用程序类型
  // 入库扫码 环节
  RECEIVE_SCAN: 'SCAN',
  // 其它入库
  RECEIVE_OTHER: 'OTHER',
  // 出库
  SEND: 'SEND',
  SHOU_GONG_RU: 'SGR',
  SERIAL_DELETE: 'DEL',
  SERIAL_MOD: 'MOD'
}

// 可配置的菜单
export const RouterInfo = {
  SAAS_MAINTAIN_BIG_AREA: { router: '/maintainArea', nameKey: 'menuMaintainArea', sort: 1 }, //维护大区路径
  SAAS_MAINTAIN_ZONE: { router: '/maintainZone', nameKey: 'menuMaintainZone', sort: 2 }, //维护储区路径
  SAAS_INTEGRATED_WORKSTATION: {
    router: '/maintainIntegratedWorkstation',
    nameKey: 'menuMaintainIntegratedWorkstation',
    sort: 3
  }, //复核打包一体化路径
  SAAS_PACKING_WORKSTATION: {
    router: '/maintainPackingWorkstation',
    nameKey: 'menuMaintainPackingWorkstation',
    sort: 4
  }, // 打包台路径
  SAAS_MUTI_OWNER: { router: '/ownerManagement', nameKey: 'menuOwnerManagement', sort: 5 }, // 货主路径
}

// 必须展示的菜单
export const NecessaryRouterInfo = [
  { router: '/cellSpecification', nameKey: 'addCellSpecification', sort: 6 }, //储位规格
  { router: '/cellMaintain', nameKey: 'addCellMaintain', sort: 7 }, //储位
  { router: '/container', nameKey: 'container1', sort: 8 }, //容器
]

export const PIECE_TYPE_SMALL = 'small'
export const PIECE_TYPE_MIDDLE = 'medium'

export const AuthErrorCode = {
  NOT_LOGIN_IN: 1000, // 未登录
  NOT_OBTAIN_TENANT: 1001, // 未获取租户
  UNAUTHORIZED: 1002 //未授权
}

// 复核台设置
export const REVIEW_DESK_SET = {
  PLATFORM_NO: 'strPlatformNo',
  ONE_PACKAGE: 'onePackageSet',
  USE_CONSUMBLES_SCAN: 'useConsumblesScan',
  USE_PARCEL_DETAIL_SCAN: 'useParcelDetailScan'
}

// 业务能力，按货主维度划分
export const BUSINESS_TAG = {
  BOX_CHECK: 'boxCheck', //箱检
  FULL_PACKAGE: 'fullPackage', //满包裹
  CONSUMABLES_SCAN: 'consumablesScan', //耗材扫描
  REPLACE_LABEL: 'replaceLabel', //换单
  SALE_CHANNEL_NOTICE: 'saleChannelNotice', //销售渠道提示（复核打包一体化页面左上角提示；businessTag第15位）,
  CHAINS_CONSUMABLE: 'chasinConsumableNotice',
  MIXING_ORDER_ON_SAMEPALLET:'mixingOrderOnSamePallet',
  NO_SCANNING_CONSUMABLES_CODE: 'noScanningConsumablesCode', // 单件订单免扫耗材
  MATCH_CONSUMABLES_TO_OWNER: 'matchConsumablesToOwner', // 强校验耗材与货主匹配
}

export const OwnerMarkEnum = {
  // 入库支持开箱预检
  inboundOpenCartonCheck: { index: 1, value: '1', code: 'inboundOpenCartonCheck', name: '开箱预检' },
  // 复核支持包裹明细采集
  fullPackage: { index: 2, value: '1', code: 'fullPackage', name: '满包裹' },
  // 复核支持扫描耗材
  consumablesScan: { index: 3, value: '1', code: 'consumablesScan', name: '耗材扫描' },
  // 复核支持换单
  replaceLabel: { index: 4, value: '1', code: 'replaceLabel', name: '换单' },
  inboundShelfReturn: { index: 5, value: '1', code: 'inboundShelfReturn', name: '库内返架' },
  masterAttributesMaintain: { index: 6, value: '1', code: 'masterAttributesMaintain', name: '属性维护' }
}

export const CartonSurfaceStatus = {
  NORMAL: 0,
  DAMAGE: 4,
  UNIDENTIFIED: 8
}

export const GoodsSurfaceStatus = {
  NORMAL: 0,
  WRONG_LABEL: 1,
  UNACCEPTABLE_SHIPPING_PACKAGE: 2,
  WRONG_DIMENSION: 3,
  DAMAGE: 4,
  UNIDENTIFIED: 8,
  OFF_LIST: 9,
  WITHOUT_BATTERY_LABEL: 10
}

export const GoodsSKUType = {
  NORMAL: 0,
  CUSTOM: 8,
  OFF_LIST: 9
}

export const ProductLevel = {
  GOOD: '100', // 良品
  DAMAGE: '200' // 残品
}

// 入库单状态
export const AsnOptTypeEnum = {
  DOWNLOAD: 1,  //入库单下传
  INIT: 100,  //初始化数据
  PUSH_BOOKING: 200,  //推送预约系统
  BOOKING_SUCCESS: 300,  //预约完成
  HANDOVER_SUCCESS: 400,  //包裹交接
  PUSH_RECEIVING: 500,  //推送验收
  START_RECEIVING: 600,  //开始验收
  RECEIVING_SUCCESS: 700,  //验收完成
  FINISH_SUCCESS: 9000,  //关单
  CANCEL: 9999,  //入库单取消
  BOOKING_DOWNLOAD: 201,  //预约单下传
  BOOKING_SIGNING: 202,  //预约单签到中
  BOOKING_SIGNED: 203,  //预约单签到完毕
  BOOKING_CANCEL: 204,  //预约单取消
  ANS_WAITING_FOR_ARRIVAL: 210,  //入库单等待到货
  ANS_ARRIVED: 220,  //入库单已到货
  ANS_UNLOADING: 230,  //入库单卸货中
  ANS_UNLOADED: 240,  //入库单卸货完毕
  ASN_BATCH_RECEIVED: 250,  //入库单批次完验
}

//盘点单分配情况
export const CheckAssignStatusLabel = {
  0: '',
  1: 'noAssign',
  2: 'partAssign',
  3: 'yesAssign',
}

//差异中心 业务类型
export const CheckOfferTypeName = {
  null: 'check',
  '': 'check',
  'CS': 'check',
  'SOW': 'SOW',
  'PUTAWAY': 'PUTAWAY',
  'RC': 'RC',
  'DYI': 'DYI',
  'CS_AR': 'CS_AR',
  'MV': 'MV',
  'RP': 'RP',
  'PK': 'PK',
  'PK_RT': 'PK_RT',
  'CK': 'CK',
  'DY': 'DY',
  'SM': 'SM',
  'KC': 'KC',
  'ROBOT': 'ROBOT',
  'XV': 'XV',
  'OSR': 'OSR',
  'ROBOTOUT': 'ROBOTOUT',
  'ROBOTIN': 'ROBOTIN',
  'BC': 'BC',
  'TRO': 'TRO',
  'ROBOTM': 'ROBOTM',
  'DS': 'DS',
  'REPLEMENT':'REPLEMENT',
  'ROBOTCYCLE':'ROBOTCYCLE',
  'CYCINVE':'CYCINVE',
  'PURCHASE_PUTAWAY':'PURCHASE_PUTAWAY',
  'REVERSE_PUTAWAY':'REVERSE_PUTAWAY',
  'MOVE_WAREHOUSE':'MOVE_WAREHOUSE',
  'TRANSFER_WAREHOUSE':'TRANSFER_WAREHOUSE',
  'PAK':'pack'
}
//差异中心入库子业务类型
export const CheckInboundType={
  'PURCHASE_PUTAWAY':'PURCHASE_PUTAWAY',
  'REVERSE_PUTAWAY':'REVERSE_PUTAWAY',
  'MOVE_WAREHOUSE':'MOVE_WAREHOUSE',
  'TRANSFER_WAREHOUSE':'TRANSFER_WAREHOUSE'
}

//打单面单模板类型
export const LabelType = {
  STORE_PACKAGE_LABEL: 'HKM_PL',
  RETURN_LABEL: 'HKM_RS',
  INVOICE_LABEL: 'HKM_INC',
  MSJ_INVOICE_LABEL: 'dpd_220825', // 马士基发票模板
  MINISO_PACKING_LIST_LABEL: 'miniso_packing_list_template', // MINISO-PACKING-LIST模板
  MINISO_PACKING_MALAYSIA: 'miniso_packlist_2', // 马来西亚MINISO-PACKING-LIST模板
  MINISO_PACKING_AUSTRALIA: 'miniso_packlist_au', // 澳大利亚MINISO-PACKING-LIST模板
  COMMON_STORE_DELIVERY: 'miniso_common_pl', // 通用门店送货单
  MINISO_PACKING_LTALY: 'miniso_packlist_it', // 澳大利亚MINISO-PACKING-LIST模板
}

//打单面单返回格式
export const ResDocFormat = {
  PDF: 'PDF',
  PNG: 'PNG',
}
//****************workerException outbound begin**************
/*
 * 拣货 任务类型
 */
export const outBoundPickingTaskTypeI18N = {
  '10': 'deductStock',//扣减库存任务
  '20': 'dataSend',//数据下发任务
  '30': 'checkIssueTask',//待鉴定，盘点,wcs下发指令任务
  '40': 'backTaskForWave',//波次回传任务
  '50': 'statusSend',//状态回传任务
}
/*
   * 拣货 业务类型
   */
export const pickingBusinessTypeI18N = {
  '1001' : 'subtractStock',
  '1002' : 'releaseStorageStock',
  '1003' : 'releaseStockPreempt',
  '1004' : 'changeContainer',
  '1005' : 'innerSubtractStock',
  '2001' : 'downToReviewByTask',
  '2002' : 'pointsConfluence',
  '2003' : 'downInnerByTask',
  '2004' : 'downToReviewByOrder',
  '2005' : 'downPointsConfluenceByOrder',
  '2006' : 'downInnerByOrder',
  '2007' : 'downOrderFinishStatus',
  '2008' : 'downPickFinishStatus',
  '2009' : 'receiveTaskDownInner',
  '2010' : 'sendOutSecondSplit',
  '2011' : 'sendOutPutShelves',
  '2012' : 'pickContainerAndRemoveStock',
  '2013' : 'releasePickingContainer',
  '2014' : 'sendOutRePackByBatchNo',
  '3001' : 'waitingIdentifyTasks',
  '3002' : 'inventoryTaskWork',
  '3003' : 'sendOutCommandForWcs',
  '3004' : 'sendUpCommandToWcs',
  '3013' : 'sendToRobot',
  '4001' : 'backTaskForWave',
  '5001' : 'writeOrderStatusTask',
  '5002' : 'writeTaskListStatusTask',
}
/*
 * 异步任务分配 任务类型
 */
export const outBoundAssignTaskTypeI18N = {
  '1001': 'assignTaskType1001',
  '1002': 'assignTaskType1002',
  '1003': 'assignTaskType1003',
  '1013': 'assignTaskType1013',
  '1004': 'assignTaskType1004',
  '1016': 'assignTaskType1016',
  '1005': 'assignTaskType1005',
  '1006': 'assignTaskType1006',
  '1007': 'assignTaskType1007',
  '1008': 'assignTaskType1008',
}
/*
 * 异步任务分配 业务类型
 */
export const outBoundAssignBusinessTypeI18N = {
  '1001' : 'assignBusinessType1001',
  '1002' : 'assignBusinessType1002',
  '1003' : 'assignBusinessType1003',
  '1013' : 'assignBusinessType1013',
  '1004' : 'assignBusinessType1004',
  '1016' : 'assignBusinessType1016',
  '1005' : 'assignBusinessType1005',
  '1006' : 'assignBusinessType1006',
  '1007' : 'assignBusinessType1007',
  '1008' : 'assignBusinessType1008',
}
/*
* check worker 出库>复核 任务类型->业务描述
*/
export const outBoundCheckBusinessTypeI18N = {
  '5'  :  'checkBusinessType5',
  '10' :  'checkBusinessType10',
  '11' :  'checkBusinessType11',
  '12' :  'checkBusinessType12',
  '13' :  'checkBusinessType13',
  '14' :  'checkBusinessType14',
  '15' :  'checkBusinessType15',
  '17' :  'checkBusinessType17',
  '18' :  'checkBusinessType18',
  '19' :  'checkBusinessType19',
  '20' :  'checkBusinessType20',
  '21' :  'checkBusinessType21',
  '22' :  'checkBusinessType22',
  '23' :  'checkBusinessType23',
  '24' :  'checkBusinessType24',
  '25' :  'checkBusinessType25',
  '30' :  'checkBusinessType30',
  '40' :  'checkBusinessType40',
  '41' :  'checkBusinessType41',
  '42' :  'checkBusinessType42',
  '43' :  'checkBusinessType43',
  '44' :  'checkBusinessType44',
  '45' :  'checkBusinessType45',
  '50' :  'checkBusinessType50',
  '55' :  'checkBusinessType55',
  '60' :  'checkBusinessType60',
  '61' :  'checkBusinessType61',
  '62' :  'checkBusinessType62',
  '65' :  'checkBusinessType65',
  '67' :  'checkBusinessType67',
  '68' :  'checkBusinessType68',
  '70' :  'checkBusinessType70',
  '16' :  'checkBusinessType16',
  '71' :  'checkBusinessType71',
  '72' :  'checkBusinessType72',
  '73' :  'checkBusinessType73',
  '75' :  'checkBusinessType75',
  '76' :  'checkBusinessType76',
  '77' :  'checkBusinessType77',
  '78' :  'checkBusinessType78',
  '79' :  'checkBusinessType79',
  '90' :  'checkBusinessType90',
  '91' :  'checkBusinessType91',
  '92' :  'checkBusinessType92',
  '94' :  'checkBusinessType94',
  '95' :  'checkBusinessType95',
  '96' :  'checkBusinessType96',
  '100' : 'checkBusinessType100',
  '110' : 'checkBusinessType110',
  '130' : 'checkBusinessType130',
  '131' : 'checkBusinessType131',
  '140' : 'checkBusinessType140',
  '150' : 'checkBusinessType150',
  '180' : 'checkBusinessType180',
  '200' : 'checkBusinessType200',
  '83'  : 'checkBusinessType83',
  '84'  : 'checkBusinessType84',
  '85'  : 'checkBusinessType85',
  '86' : 'checkBusinessType86',
  '87' : 'checkBusinessType87',
}
/*
* wave exception WaveTypeEnum
*/
export const waveExceptionWaveTypeI18n = {
  '1'  : 'exceptionTypeForLocating',
  '2'  : 'exceptionTypeForBale',
  '3'  : 'exceptionTypeForInit',
  '4'  : 'exceptionTypeForWave',
  '5'  : 'exceptionTypeForShip',
  '6'  : 'exceptionTypeForOTM',
  '7'  : 'exceptionTypeForMQ',
  '8'  : 'exceptionTypeForPrint',
  '9'  : 'exceptionTypeForScrapped',
  '10' : 'exceptionTypeForUpdate',
  '11' : 'exceptionTypeForReminder',
  '12' : 'exceptionTypeForReject',
}
/*
* locate Exception taskType
*/
export const locateExceptionTaskTypeI18n = {
  '11' : 'releaseInventoryPreemptedTask',
  '21' : 'emergencyReplenishmentTask',
}
/*
* BackSend Exception taskType
*/
export const locateBackSendExceptionI18n = {
  '41' : 'backForWave',
  '51' : 'backForTask',
  '61' : 'backForDelivery',
}
//end



//在库-库存Worker任务类型
export const StockWorkerType = {
  '0': 'StockWorkerType0',
  '1': 'StockWorkerType1',
  '2': 'StockWorkerType2',
  '3': 'StockWorkerType3',
  '4': 'StockWorkerType4',
  '5': 'StockWorkerType5',
  '6': 'StockWorkerType6',
  '7': 'StockWorkerType7',
  '8': 'StockWorkerType8',
  '9': 'StockWorkerType9',
  '10': 'StockWorkerType10',
  '11': 'StockWorkerType11',
  '12': 'StockWorkerType12',
  '13': 'StockWorkerType13',
  '14': 'StockWorkerType14',
  '15': 'StockWorkerType15',
  '21': 'StockWorkerType21',
  '22': 'StockWorkerType22',
  '23': 'StockWorkerType23',
  '24': 'StockWorkerType24',
  '25': 'StockWorkerType25',
  '20': 'StockWorkerType20',
  '30': 'StockWorkerType30',
  '31': 'StockWorkerType31',
  '33': 'StockWorkerType33',
  '40': 'StockWorkerType40',
  '41': 'StockWorkerType41',
  '42': 'StockWorkerType42',
  '50': 'StockWorkerType50',
  '51': 'StockWorkerType51',
  '52': 'StockWorkerType52',
  '53': 'StockWorkerType53',
  '54': 'StockWorkerType54',
  '55': 'StockWorkerType55',
  '60': 'StockWorkerType60',
  '61': 'StockWorkerType61',
  '62': 'StockWorkerType62',
  '63': 'StockWorkerType63',
  '70': 'StockWorkerType70',
  '71': 'StockWorkerType71',
  '72': 'StockWorkerType72',
  '80': 'StockWorkerType80',
  '91': 'StockWorkerType91',
  '81': 'StockWorkerType81',
  '82': 'StockWorkerType82',
  '83': 'StockWorkerType83',
  '145': 'StockWorkerType145',
  '150': 'StockWorkerType150',
  '146': 'StockWorkerType146',
  '147': 'StockWorkerType147',
  '151': 'StockWorkerType151',
  '172': 'StockWorkerType172',
  '173': 'StockWorkerType173',
  '174': 'StockWorkerType174',
  '175': 'StockWorkerType175',
}

//LogicAreaJobType
export const LogicAreaJobType = {
  'W0100': 'jobTypeW0100',
  'W0200': 'jobTypeW0200',
  'W0300': 'jobTypeW0300',
  'W0400': 'jobTypeW0400',
  'W0500': 'jobTypeW0500',
  'W0600': 'jobTypeW0600',
  'W0700': 'jobTypeW0700',
}

//业务类型
export const BussinessTaskType = {
  '1001': 'taskType1001',
  '1002': 'taskType1002',
  '1003': 'taskType1003',
  '1101': 'taskType1101',
  '1201': 'taskType1201',
  '1301': 'taskType1301',
  '1501': 'taskType1501',
  '1801': 'taskType1801',
  '1901': 'taskType1901',
  '2001': 'taskType2001',
}

//task_type_no 任务类型
export const BussinessTaskTypeNo = {
  '': '',
  '1001': 'BTaskType1001',
  '1002': 'BTaskType1002',
  '1003': 'BTaskType1003',
  '1101': 'BTaskType1101',
  '1201': 'BTaskType1201',
  '1301': 'BTaskType1301',
  '1501': 'BTaskType1501',
  '1801': 'BTaskType1801',
  '1901': 'BTaskType1901',
  '2001': 'BTaskType2001',
  '1802': 'BTaskType1802',
  '20440999': 'BTaskType20440999',
  '20406999': 'BTaskType20406999',
  '20414999': 'BTaskType20414999',
  '20433999': 'BTaskType20433999',
  '20422999': 'BTaskType20422999',
  '20424999': 'BTaskType20424999',
  '20423999': 'BTaskType20423999',
  '1': 'BTaskType1',
  '2': 'BTaskType2',
  '5': 'BTaskType5',
  '20401999': 'BTaskType20401999',
  '1004': 'BTaskType1004',
  '20419999': 'BTaskType20419999',
  '20426999':'BTaskType20426999',
  '20414666': 'BTaskType20414666',
  '2501': 'BTaskType2501',
  '1005': 'BTaskType1005',
  '1826': 'BTaskType1826',
  '1827': 'BTaskType1827',
  '1828': 'BTaskType1828',
  '1829': 'BTaskType1829',
  '1830': 'BTaskType1830',
  '1833': 'BTaskType1833',
  '1834': 'BTaskType1834',
  '1009': 'BTaskType1009',
  '1803': 'BTaskType1803',
  '1831': 'BTaskType1831',
  '1832': 'BTaskType1832',
  '1011': 'BTaskType1011',
  '1601': 'BTaskType1601',
  '2601': 'BTaskType2601',
  '2602': 'BTaskType2602',
  '2603': 'BTaskType2603',
  '1602': 'BTaskType1602',
  '1603': 'BTaskType1603',
  '1604': 'BTaskType1604',
  '1010': 'BTaskType1010',
  '1006': 'BTaskType1006',
  '1835': 'BTaskType1835',
  '1836': 'BTaskType1836',
  '1008': 'BTaskType1008',
  '1007': 'BTaskType1007',
  '1611': 'BTaskType1611',
  '1730': 'BTaskType1730',
  '1731': 'BTaskType1731',
  '1740': 'BTaskType1740',
  '1750': 'BTaskType1750',
  '1720': 'BTaskType1720',
  '1036': 'BTaskType1036',
  '1770': 'BTaskType1770',
  '1780': 'BTaskType1780',
  '1620': 'BTaskType1620'
}

// 订单状态
//0:不允许缺量 1:允许缺量
export const ShortFlag = {
  NOT_ALLOW: 0,
  ALLOW: 1
}

// 货权转移单状态
export const OrderChangeStatus = {
  '1': 'init',
  '2': 'tkPositioning',
  '25': 'shortageLocate',
  '3': 'locateException',
  '4': 'yesAssign',
  '5': 'received',
  '51': 'autoDowning',
  '6': 'offEnd',
  '61': 'autoShelfing',
  '7': 'putAwayEnd',
  '8': 'canceled',
  '10': 'locating',
  '11': 'orderGeneration',
  '12': 'orderCompletion',
}

// 货权转移单业务类型
export const OrderChangeBusinessType = {
  '1': 'orderChange',
}

export const GoodsLevel = {
  '100': 'goodProduct',
  '200': 'damagePart',
}

//出库占用释放容器业务类型
export const containerBussinessType = {
  Picking: 'OUTBOUND_PICKING',//拣货
  Rebin_Check_TurnBox: 'OUTBOUND_REBIN_CHECK_TURNBOX',//rebin 复核
  ReturnPack: 'OUTBOUND_RETURN_PACK',//库内返架
  New_ReturnPack:'OUTBOUND_NEW_RETURN_PACK',//新版库内反架
  Check_TurnBox: 'OUTBOUND_CHECK_TRUNBOX',//复核打包一体化
  Pack_Differ: 'OUTBOUND_PACK_DIFFER', // 打包su-独立打包
  B2B_Shipment_Intercept: 'OUTBOUND_B2B_SHIPMENT_INTERCEPT',//B2B发货拦截
  B2B_Check_Pallet: 'OUTBOUND_B2B_CHECK_PALLET',//B2B复核
  NonCustomer_Check:'OUTBOUND_NON_CUSTOMER_CHECK',//非客单复核
  HKM_Rebin_Check_TurnBox: 'OUTBOUND_HKM_REBIN_CHECK_TURNBOX',//HKM rebin
  Robot_Adapter_Zero_Picking: 'OUTBOUND_ROBOT_ADAPTER_ZERO_PICKING',//地狼机器零拣货
  Close_Container_Worker: 'OUTBOUND_RELEASE_CONTAINER_WORKER',//释放容器worker
  Package_Auto_Check: 'OUTBOUND_AUTO_CHECK_TO_PACKAGE',//自动复核按包裹
  Order_Auto_Check: 'OUTBOUND_AUTO_CHECK_TO_ORDER',//自动复核按订单
}

//VAS占用容器业务类型
export const vasContainerBusinessType = {
  "AGVPick":"occupyAgvPick",
  "5555":"occupyAgvPick",
  "INBOUND-RECEIVING":"occupyInboundReceiving",
  "INBOUND-RETURN-RECEIVING":"occupyInboundReturnReceiving",
  "invop":"occupyInvop",
  "OUTBOUND_B2B_CHECK_PALLET":"occupyOutboundB2BCheckPallet",
  "OUTBOUND_CHECK_TRUNBOX":"occupyOutboundCheckTrunBox",
  "OUTBOUND_NON_CUSTOMER_CHECK":"occupyOutboundNonCustomerCheck",
  "OUTBOUND_PICKING":"occupyOutboundPicking",
  "OUTBOUND_REBIN_CHECK_TURNBOX":"occupyOutboundReBinCheckTurnBox",
  "OUTBOUND_RETURN_PACK":"occupyOutboundRerurnPack",
  "Putaway":"occupyPutaway",
  "VAS_NEW":"occupyVasNew",
  "unknow":"occupyUnknow",
  "INVOP-ORDERCHANGE": "occupyInvopOrderChange",
  "INVOP-DIRECTTRANS": "occupyInvopDirectTrans",
  "INVOP-REPLENISHMENT-OFFSHELF": "occupyInvopReplenishmentOffShelf",
}

// 商品批属性类型
export const batchAttributeType = {
  receiving_date_lot: 'baseItemInboundDate',//'入库日期',
  production_date_lot: 'productDate',// '生产日期'
  isPackageBatch: 'isPackageBatch', // 包装批号
  expiration_date_lot: 'maturityDate' // 到期日期
}
// 箱子类型
export const boxType = [
  {
    value: 0,
    label: 'common' // 非箱规
  },
  {
    value: 1,
    label: 'boxRule' // 箱规码
  },
  {
    value: 2,
    label: 'lpn' // 托
  }
]

//面单类型枚举 0：老面单，1：新面单，2：印尼, 3:其他(包含德国，纯仓等)
export const cloudPrintFaceLabelType = {
  OLD_ORDER: 0,                 // 老面单
  NEW_ORDER: 1,                 // 新面单
  INDONESIA_ORDER: 2,           // 印尼
  OVERSEAS_ORDER: 3,            // 海外其他
  MCA_SELFPICKUP_NEW_LABEL: 4   // MCA人工自提纯仓新面单
}
// 储区类型
export const zoneType = [
  {
    value: 'n',
    label: 'generalSortingArea'
  }, {
    value: 'd',
    label: 'orderArea'
  },{
    value: 'robot',
    label: 'robot'
  },{
    value: 'rh',
    label: 'reservedHold'
  },
  {
    value: 'big',
    label: 'bigArea'
  }
]

// WMS映射3pl面单类型枚举
export const shipmentLabelType = {
  forward_label: 0, // 3pl正向面单
  reverse_label: 1, // 3pl逆向面单
  invoice: 2, // 发票
  packing_list: 3, // packingList/打包明细
  order_reverse_label: 11, // 随单逆向面单
  shipping_paper: 5, // shipping_paper
  package_invoice: 8, // 包裹维度发票
  zpl: 10, //zpl面单
  zhuimi_label: 16 //追觅箱唛
}

// 面单类型映射
export const waybillTypeMapping = {
  // 0: 'faceSheetLabel',
  // 1: 'reverseLabel',
  2: 'ticket',
  3: 'packingDetail',
  5: 'shipping_paper',
  // 10: 'zpl面单',
  11: 'reverseLabel',
  // 12: 'countryLabel',
  13: 'zibuyuFBABoxLabel',
  14: 'shippingDoc',
  20: 'DjPackingSSCC',
  21: 'DjPackingASN',
  29: 'countryLabel',
}

// 3pl面单类型枚举
export const labelKindFor3pl = {
  FORWARD: 'FORWARD', // 3pl正向面单
  RETURNED: 'RETURNED', // 3pl逆向面单
  SHIPPING_PAPER: 'SHIPPING_PAPER', // 3PL返回SHIPPING_PAPER单据
  INVOICE: 'INVOICE' // 发票（3pl返回报文中和labels同级的attachLabels下）
}

// 3pl面单类型枚举
export const faceSheetsFor3pl = [
  {
    label: 'ticket',
    value: 1,
    desc: '发票(Invoice)'
  },
  {
    label: 'returnSheet',
    value: 2,
    desc: '退货单(Return Sheet)'
  },
  {
    label: 'packingList',
    value: 3,
    desc: '大箱明细(Packing List)'
  },
  {
    label: 'middleLabel',
    value: 4,
    desc: '中性面单(Middle Label)'
  },
  {
    label: 'podType',
    value: 5,
    desc: 'POD文件(Pod_Type)'
  },
  {
    label: 'innerLabel',
    value: 6,
    desc: '内部面单(Inner Label)'
  },
  {
    label: 'inboundLabel',
    value: 7,
    desc: '入仓单(Inbound Label)'
  },
  {
    label: 'interfaceFile',
    value: 8,
    desc: '接口传送的文件(Interface File)'
  },
  {
    label: 'hisenseDeliveryLabel',
    value: 9,
    desc: '送货单(Delivery note)'
  },
  {
    label: 'invoiceReturn',
    value: 10,
    desc: '发票逆向(Invoice Return)'
  },
  {
    label: 'hazardousDocuments',
    value: 11,
    desc: '危险品文件(Hazardous documents)'
  },
  {
    label: 'manifest',
    value: 12,
    desc: '危险品的manifest文件(Manifest)'
  },
  {
    label: 'returnFlyer',
    value: 13,
    desc: '退货宣传单(Return Flyer)'
  },
  {
    label: 'manifestFile',
    value: 14,
    desc: 'manifest文件'
  },
  {
    label: 'reverseLabel',
    value: 17,
    desc: '逆向面单(REVERSE_LABEL)'
  },
  {
    label: 'Hisense_OTTO_label',
    value: 18,
    desc: 'Hisense-OTTO label'
  },
  {
    label: 'giftCard',
    value: 19,
    desc: 'giftCard'
  },
  {
    label: 'vasCard',
    value: 23,
    desc: '礼品卡-增值服务(Card-VAS)'
  }
]

// 异步导出任务状态枚举
export const asyncExportTaskStatus = [
  {
    label: 'createSuccess',
    value: 10,
    desc: '创建成功'
  },
  {
    label: 'toBeExecuted',
    value: 20,
    desc: '待执行'
  },
  {
    label: 'inExecution',
    value: 30,
    desc: '执行中'
  },
  {
    label: 'failedToTryAgain',
    value: 40,
    desc: '失败待重试'
  },
  {
    label: 'executionFailed',
    value: 50,
    desc: '执行失败'
  },
  {
    label: 'executionCompleted',
    value: 60,
    desc: '执行完成'
  }
]
// 耗材类型
export const consumablesType = [
  {
    label: 'selfPurchasedConsumables',
    value: 'jd',
    desc: '自采耗材'
  },
  {
    label: 'delegateConsumables',
    value: 'delegate',
    desc: '代采耗材'
  },
  {
    label: 'merchantConsumables',
    value: 'merchant',
    desc: '商家耗材'
  }
]
// 机区储位来源
export const robotCellSourceList = [
  {
    label: 'all',
    value: null,
  },
  {
    label: 'wolfDay',
    value: 0,
  },
  {
    label: 'wolfTo',
    value: 1,
  },
  {
    label: 'wolfSky',
    value: 2,
  },
  {
    label: 'softSea',
    value: 3,
  }
]

// 计费储位类型
export const feeShelfTypeList = [
  {
    label: 'heroHeapBits',
    value: 0,
    desc: '英标地堆位'
  },
  {
    label: 'europeanHeapBits',
    value: 1,
    desc: '欧标地堆位'
  },
  {
    label: 'heteroideusHeapBits',
    value: 2,
    desc: '异形地堆位'
  },
  {
    label: 'elevated',
    value: 3,
    desc: '高架'
  },
  {
    label: 'narrowRoadway',
    value: 4,
    desc: '窄巷道'
  },
  {
    label: 'clapboardS',
    value: 5,
    desc: '隔板S'
  },
  {
    label: 'clapboardL',
    value: 6,
    desc: '隔板L'
  },
  {
    label: 'AGVCargoCellOne',
    value: 7,
    desc: 'AGV货格1分格'
  },
  {
    label: 'AGVCargoCellTwo',
    value: 8,
    desc: 'AGV货格2分格'
  },
  {
    label: 'AGVCargoCellFour',
    value: 9,
    desc: 'AGV货格4分格'
  },
  {
    label: 'CTUContainerOneCell',
    value: 10,
    desc: 'CTU料箱1分格'
  },
  {
    label: 'CTUContainerTwoCell',
    value: 11,
    desc: 'CTU料箱2分格'
  },
  {
    label: 'CTUContainerFourCell',
    value: 12,
    desc: 'CTU料箱4分格'
  },
  {
    label: 'CTUContainerEightCell',
    value: 13,
    desc: 'CTU料箱8分格'
  },
  {
    label: 'AGVPalletGrid',
    value: 14,
    desc: 'AGV托盘货格'
  },
  {
    label: 'specialShapedHeap',
    value: 15,
    desc: '异形地堆位2'
  },
]


// 入库流向类型枚举
export const flowZoneType = {
  humanArea: {
    value: 0,
    label: 'H',
    desc: '人区'
  },
  robotArea: {
    value: 1,
    label: 'R',
    desc: '机区'
  },
}
/**
 * ctu入库格口类型枚举
 * 目前四类，即格口的容器类型: 10,20,40,80,21,41
 * 前面的数字标识了格口数量,后面的标识容器类型
 * 当前不同的格口数量的容器都是统一的类型，即都是0，后续可以扩展
 * wsc新增四类 10,22,42,81
 */
export const inboundCtuGridType = [
  {
    label: 'onePoint',
    value: 10,
    code: 'A1'
  },
  {
    label: 'twoPoint',
    value: 20,
    code: 'OldA2'
  },
  {
    label: 'fourPoint',
    value: 40,
    code: 'OldA4'
  },
  {
    label: 'eightPoint',
    value: 80,
    code: 'A8'
  },
  {
    label: 'twoPointUpDown',
    value: 21,
    code: 'NewA2'
  },
  {
    label: 'fourPointUpDown',
    value: 41,
    code: 'NewA4'
  },
  {
    label: 'wcsOnePoint',
    value: 11,
    code: 'wcsA1'
  },
  {
    label: 'wcsTwoPoint',
    value: 22,
    code: 'wcsA2'
  },
  {
    label: 'wcsFourPoint',
    value: 42,
    code: 'wcsA4'
  },
  {
    label: 'wcsEightPoint',
    value: 81,
    code: 'wcsA8'
  },
]

// 维保商品成色
export const maintenanceProductConditionList = [
  {
    label: 'brandNew',
    value: 1
  },
  {
    label: 'almostNew',
    value: 2
  },
  {
    label: 'ninePercentNew',
    value: 3
  },
  {
    label: 'eightPercentNew',
    value: 4
  },
  {
    label: 'fivePercentNew',
    value: 5
  },
  {
    label: 'badGood',
    value: 6
  }
]

// 万件损益-责任方枚举
export const responsiblePartyTypeList = [
  {
    label: 'wmsResp',
    desc: '仓储责',
    value: 1
  },
  {
    label: 'clientResp',
    desc: '客户责',
    value: 2
  },
  {
    label: 'tmsResp',
    desc: '运输责',
    value: 3
  },
  {
    label: 'other',
    desc: '其他',
    value: 4
  }
]
// 万件损益-残品类型枚举
export const allDamagedTypeList = [
  {
    // key与责任方枚举value保持一致
    key: 1,
    label: 'wmsResp',
    list: [
      {
        label: 'inventoryDamageWms',
        desc: '商品损-仓储',
        value: 11,
        text: 'inventoryDamageWmsDetail'
      },
      {
        label: 'packagingDamage',
        desc: '包装损',
        value: 12,
        text: 'packagingDamageDetail'
      },
      {
        label: 'inventoryDiscrepancy',
        desc: '库存差异',
        value: 13,
        text: 'inventoryDiscrepancyDetail'
      },
      {
        label: 'relocationDiscrepancy',
        desc: '搬仓差异',
        value: 14,
        text: 'relocationDiscrepancyDetail'
      }
    ]
  },
  {
    key: 2,
    label: 'clientResp',
    list: [
      {
        label: 'productQualityIssues',
        desc: '商品质量问题',
        value: 21,
        text: 'productQualityIssuesDetail'
      },
      {
        label: 'expirationDateProducts',
        desc: '临期商品',
        value: 22,
        text: 'expirationDateProductsDetail'
      },
      {
        label: 'returnableProducts',
        desc: '退供商品',
        value: 23,
        text: 'returnableProductsDetail'
      },
      {
        label: 'reverseLoss',
        desc: '逆向损',
        value: 24,
        text: 'reverseLossDetail'
      },
      {
        label: 'inventoryVarianceCustomer',
        desc: '库存差异-客户',
        value: 25,
        text: 'inventoryVarianceCustomerDetail'
      }
    ]
  },
  {
    key: 3,
    label: 'tmsResp',
    list: [
      {
        label: 'transportationDamage',
        desc: '到货运输损',
        value: 31,
        text: 'transportationDamageDetail'
      }
    ]
  },
  {
    key: 4,
    label: 'other',
    list: [
      {
        label: 'insuranceReportPending',
        desc: '保险索赔待处理',
        value: 41,
        text: 'insuranceReportPendingDetail'
      }
    ]
  }
]

// 托规采集方式 托规采集方式 1: 组托时采集(默认) 2: 组托后集中采集
export const b2boutBoundPalletCollectingWay = {
  // 默认(配置1或者不配置) 组托时采集
  collectDuringAssembly: 1,
  // 组托后集中采集
  centralizedCollectAfterGrouping: 2
}

// 尾程服务商规则类型
export const analysisRulesList = [
  {
    code: 1,
    name: 'DPD',
  },
  {
    code: 2,
    name: 'FedEx',
  },
  {
    code: 3,
    name: 'USPS',
  },
  {
    code: 5,
    name: 'DHL',
  },
  {
    code: 6,
    name: 'GLS',
  }
]

export const serialOperationList=[
  {
    label: 'addSerialNo',
    value: 1,
  },
  {
    label: 'releaseSerialNo',
    value: 2,
  },
  {
    label: 'deleteSerial',
    value: 3,
  },
  {
    label: 'lockSerial',
    value: 4,
  },
  {
    label: 'unlockSerialNo',
    value: 5,
  },
  {
    label: 'addIMEL',
    value: 6,
  }
]
// 盘点类型
export const inventoryTypeList=[
  {
    label:'dynamicInventory',
    value:2
  },
  {
    label:'staticInventory',
    value:1
  }
]
// 盘点方式
export const inventoryMethodList=[
  {
    label:'cellType',
    value:1
  },
  {
    label:'goodsType',
    value:2
  },
  {
    label:'movingType',
    value:3
  },
  {
    label:'ownerType',
    value:10
  },
  {
    label:'LPNType',
    value:20
  },
  {
    label:'preciousPlate',
    value:25
  },
  {
    label:'riskPlate',
    value:26
  },
  {
    label:'dynamicTouchPlate',
    value:27
  }
]
// 分配情况
export const assignStatusList=[
  {
    label:'noAssign',
    value:1
  },
  {
    label:'partAssign',
    value:2
  },
  {
    label:'yesAssign',
    value:3
  }
]
//详情枚举
export const detailFormList = {
  //储位盘
    "1":[
      {
        label:"checkTypeLabel",
        value:"checkType"
      },
      {
        label:"checkStyleLabel",
        value:"checkStyle"
      },
      {
        label:"regionalCode",
        value:"areaNo"
      },
      {
        label:"zoneNo",
        value:"zoneNos"
      },
      {
        label:"aisle",
        value:"aisles"
      },
      {
        label:"cellNo",
        value:"cellNos"
      }
    ],
  // 商品盘
  "2":[
      {
        label:"checkType",
        value:"checkType"
      },
      {
        label:"checkStyleLabel",
        value:"checkStyle"
      },
      {
        label:"goodsNoLabel",
        value:"goodsNos"
      }
  ],
  // 动销盘
  "3":[
      {
        label:"checkTypeLabel",
        value:"checkType"
      },
      {
        label:"checkStyleLabel",
        value:"checkStyle"
      },
      {
        label:"regionalCode",
        value:"areaNo"
      },
      {
        label:"zoneNo",
        value:"zoneNos"
      },
      {
        label:"aisle",
        value:"aisles"
      },
      {
        label:"type",
        value:"dsType"
      },
      {
        label:"saleDate",
        value:"startTime"
      },
      {
        label:"cellNo",
        value:"cellNos"
      }
  ],
  // 货主盘
  "10":[
      {
        label:"checkType",
        value:"checkType"
      },
      {
        label:"checkStyleLabel",
        value:"checkStyle"
      },
      {
        label:"ownerLabel",
        value:"ownerNo"
      },
      {
        label:"Jdskucode",
        value:"goodsNos"
      }
  ],
  // LPN盘
  "20":[
    {
      label:"checkType",
      value:"checkType"
    },
    {
      label:"checkStyleLabel",
      value:"checkStyle"
    },
    {
      label:"LPN",
      value:"lpn"
    },
  ],
  // 贵品盘
  "25":[
      {
        label:"checkType",
        value:"checkType"
      },
      {
        label:"checkStyleLabel",
        value:"checkStyle"
      },
      {
        label:"goodsNoLabel",
        value:"goodsNos"
      }
  ],
}

export const commonDetail = [
  {
    label:"nullCell",
    value:'isContainNullCell'
  },
  {
    label:"yieldCell",
    value:'hasGoodLoc'
  },
  {
    label:"isSaleModel",
    value:'saleModelFlag'
  },
]



export const ContainerHandoverOperationEnum = {
  0: "scanContainerNoLabel",
  1: "handoverSuccess",
}

export const workbenchesType = [
  { value: 'review_site', labelKey: 'peopleReviewSite' }, // 人工复核台
  { value: 'pkMachine', labelKey: 'pkMachine' },    // 打包台
  { value: 'auto_review_site', labelKey: 'deviceReviewSite' }, // 人工复核台
  { value: 'vas_site', labelKey: 'vasWorkbench' }
]


export const RuntimeConfig = {
  templateType: 3,
  templateName: '运行时间配置',
}
export const zoneTypeEmum = {
  'n': 'generalSortingArea',
  'd': 'orderArea',
  'robot': 'robotArea',
  'rh': 'reservedHold',
  'big': 'bigArea',
  'li': 'priorityArea',
  'rma': 'rmaArea',
}
export const pickingFlagEmum = {
  'cp': 'casePicking',
  's': 'cellStorage',
  'bp': 'boxPick',
  'rh': 'reservedHold',
  'b': 'cellDefective',
  'rsvhold': 'reserved',
}

// 洲际枚举
export const IntercontinentalEnum = [
  { label: "AM", value: "AM" },
  { label: "AP", value: "AP" },
  { label: "EU", value: "EU" },
  { label: "ME", value: "ME" }
]
// 运营模式枚举
export const OperationModeEnum = [
  { label: "selfWh", value: 2 },
  { label: "tempSelf", value: 19 },
  { label: "collaborative", value: 3 },
  { label: "collaborative", value: 20 },
  { label: "system", value: 4 },
  { label: "firstLeg", value: 21 }
]

// 仓类型枚举
export const WhtypeEnum = [
  { label: "custom", value: '1' },
  { label: "smallMedium", value: '2' },
  { label: "sizeL", value: '3' },
  { label: "comprehensive", value: '4' },
  { label: "coldChain", value: '5' },
  { label: "testWarehouse", value: '25' },
]


// Band枚举
export const BandEnum = [
  {
      "label": "A",
      "value": "A"
  },
  {
      "label": "B",
      "value": "B"
  },
  {
      "label": "C",
      "value": "C"
  },
  {
      "label": "D",
      "value": "D"
  }
]

// 特殊单号规则解析
export const SpecialNoRuleList = [
  { label:'empty', value:null},
  { label:'DPD-UK', value:1},
  { label:'FedEx', value:2},
  { label:'USPS', value:3},
  { label:'AusPost', value:4},
  { label:'DHL', value:5},
  { label:'GLS', value:6},
]

// 储区类型
export const ZONETYPELIST = [
  {
    value: 'n',
    label: 'generalSortingArea',
    pickingFlags: ['cp','s','bp'],
    notModify: false,
  },
  {
    value: 'd',
    label: 'orderArea',
    pickingFlags:['b'],
    notModify: true,
  },
  {
    value: 'robot',
    label: 'robotArea',
    pickingFlags:['cp', 's'],
    notModify: true,
  },
  {
    value: 'rh',
    label: 'reservedHold',
    pickingFlags:['rsvhold'],
    notModify: true
  },
  {
    value: 'big',
    label: 'bigArea',
    pickingFlags:['cp','s'],
    notModify: true
  },
  {
    value: 'li',
    label: 'priorityArea',
    pickingFlags:['cp'],
    notModify: false
  },
  {
    value: 'rma',
    label: 'rmaArea',
    pickingFlags:['b'],
    notModify: true
  },
  {
    value: 'c',
    label: 'consumableArea',
    pickingFlags:['cp'],
    notModify: true
  },
  {
    value: 'qt',
    label: 'quickTurnoverZone',
    pickingFlags:['cp'],
    notModify: true
  },
  {
    value: 'e',
    label: 'exceptionTempZone',
    pickingFlags:['cp'],
    notModify: true
  },
  { 
    value: 'f',
    label: 'scrapYard',
    pickingFlags:['f'],
    notModify: false
  },
  {
    value: 'h',
    label: 'expenciveYard',
    pickingFlags:['cp', 's'],
    notModify: false
  }
]

export const PICKINGFLAG = [
  {
    value: 'cp',
    label: 'scatteredPickingArea',
    notModify: false
  }, {
    value: 's',
    label: 'storageArea',
    notModify: false
  }, {
    value: 'bp',
    label: 'boxPickingArea',
    notModify: true
  }, {
    value: 'b',
    label: 'orderArea',
    notModify: true
  },
  {
    value: 'rsvhold',
    label: 'reserved',
    notModify: true
  },
  {
    value: 'f',
    label: 'scrapYard',
    notModify: true
  }
]
